import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ReconciliationOverview from './reconcile/ReconciliationOverview';
import ReconciliationView from './reconcile/ReconciliationView';

/**
 * Cash & bank → Reconcile. The bank accounts, or one reconciliation when
 * `?rec=` names it (so a reconciliation in progress deep-links).
 */
const ReconciliationPanel: React.FC = () => {
  const [params, setParams] = useSearchParams();
  const recId = params.get('rec');
  const go = (id: string | null) => {
    const next = new URLSearchParams(params);
    if (id) next.set('rec', id); else next.delete('rec');
    setParams(next);
  };
  return recId ? <ReconciliationView id={recId} onBack={() => go(null)} /> : <ReconciliationOverview onOpen={go} />;
};

export default ReconciliationPanel;
